(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7958],{

/***/ 26308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ContactForm; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(50259);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/Alert/Alert.tsx + 1 modules
var Alert = __webpack_require__(60585);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/Button/Button.tsx + 1 modules
var Button = __webpack_require__(83537);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/services/contact.service.ts
var contact_service = __webpack_require__(20644);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/ContactForm/ContactForm.elements.tsx



var Background = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactFormelements__Background",
  componentId: "sc-y2oqks-0"
})(["background:", ";margin-bottom:", ";"], function (props) {
  return props.withoutBackground ? props.theme.colors.white : props.theme.colors.darkLight;
}, (0,polished_esm/* rem */.hO)(240));
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactFormelements__Wrapper",
  componentId: "sc-y2oqks-1"
})(["padding:", ";margin-top:", ";display:flex;flex-direction:column;align-items:center;@media (min-width:", "px){padding:", " 0;}"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(40), theme/* breakpoints.lg */.A.lg, (0,polished_esm/* rem */.hO)(20));
var Form = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ContactFormelements__Form",
  componentId: "sc-y2oqks-2"
})(["background:", ";padding:", ";border-radius:", ";margin-bottom:", ";box-shadow:0 5px 10px 0 rgba(0,0,0,0.15);"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.white;
}, (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(16), (0,polished_esm/* rem */.hO)(-200));
var FormFieldsStyles = (0,styled_components_browser_esm/* css */.iv)(["width:100%;padding:", ";margin-bottom:", ";border:1px solid ", ";border-radius:", ";display:block;&.error{margin-bottom:0;border-color:", ";}@media (min-width:", "px){width:", ";}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(20), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.border;
}, (0,polished_esm/* rem */.hO)(8), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.danger;
}, theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(700));
var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "ContactFormelements__Input",
  componentId: "sc-y2oqks-3"
})(["", " height:", ";"], FormFieldsStyles, (0,polished_esm/* rem */.hO)(50));
var TextArea = styled_components_browser_esm/* default.textarea.withConfig */.ZP.textarea.withConfig({
  displayName: "ContactFormelements__TextArea",
  componentId: "sc-y2oqks-4"
})(["", " height:", ";"], FormFieldsStyles, (0,polished_esm/* rem */.hO)(150));
var ErrorMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ContactFormelements__ErrorMessage",
  componentId: "sc-y2oqks-5"
})(["margin:", " 0 ", " 0;display:block;font-size:", ";color:", ";"], (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(10), function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.textBase;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.danger;
});
var GlobalErrorMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ContactFormelements__GlobalErrorMessage",
  componentId: "sc-y2oqks-6"
})(["color:", ";padding-top:", ";margin-bottom:-", ";display:block;"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.danger;
}, (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(10));
var SuccessMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ContactFormelements__SuccessMessage",
  componentId: "sc-y2oqks-7"
})(["color:", ";padding-top:", ";display:block;"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.green;
}, (0,polished_esm/* rem */.hO)(20));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/ContactForm/ContactForm.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var ContactFormTemplate = function ContactFormTemplate(_ref) {
  var withoutBackground = _ref.withoutBackground;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var router = (0,next_router.useRouter)();
  var nameInputRef = (0,react.useRef)();
  var emailInputRef = (0,react.useRef)();
  var phoneInputRef = (0,react.useRef)();
  var messageInputRef = (0,react.useRef)();

  var _useState = (0,react.useState)(false),
      hasNameError = _useState[0],
      setHasNameError = _useState[1];

  var _useState2 = (0,react.useState)(false),
      hasEmailError = _useState2[0],
      setHasEmailError = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      hasMessageError = _useState3[0],
      setMessageError = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      hasSentError = _useState4[0],
      setHasSentError = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      isLoading = _useState5[0],
      setIsLoading = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      isSent = _useState6[0],
      setIsSent = _useState6[1];

  var _useState7 = (0,react.useState)(null),
      token = _useState7[0],
      setToken = _useState7[1];

  var handleClick = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _nameInputRef$current, _emailInputRef$curren, _emailInputRef$curren2, _messageInputRef$curr;

      var hasError, _nameInputRef$current2, _nameInputRef$current3, _emailInputRef$curren3, _phoneInputRef$curren, _phoneInputRef$curren2, _messageInputRef$curr2, _window, _window$fbq, data;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setHasNameError(false);
              setHasEmailError(false);
              setMessageError(false);
              setHasSentError(false);
              setIsSent(false);
              hasError = false;

              if (!((nameInputRef === null || nameInputRef === void 0 ? void 0 : (_nameInputRef$current = nameInputRef.current) === null || _nameInputRef$current === void 0 ? void 0 : _nameInputRef$current.value) === '')) {
                _context.next = 9;
                break;
              }

              setHasNameError(true);
              return _context.abrupt("return");

            case 9:
              if (!((emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren = emailInputRef.current) === null || _emailInputRef$curren === void 0 ? void 0 : _emailInputRef$curren.value) === '' || !constants/* EMAIL_REGEX.test */.CU.test(emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren2 = emailInputRef.current) === null || _emailInputRef$curren2 === void 0 ? void 0 : _emailInputRef$curren2.value))) {
                _context.next = 12;
                break;
              }

              setHasEmailError(true);
              return _context.abrupt("return");

            case 12:
              if (!((messageInputRef === null || messageInputRef === void 0 ? void 0 : (_messageInputRef$curr = messageInputRef.current) === null || _messageInputRef$curr === void 0 ? void 0 : _messageInputRef$curr.value) === '')) {
                _context.next = 15;
                break;
              }

              setMessageError(true);
              return _context.abrupt("return");

            case 15:
              if (!hasError) {
                _context.next = 17;
                break;
              }

              return _context.abrupt("return");

            case 17:
              _context.prev = 17;
              setIsLoading(true);
              data = _objectSpread(_objectSpread(_objectSpread({}, (nameInputRef === null || nameInputRef === void 0 ? void 0 : (_nameInputRef$current2 = nameInputRef.current) === null || _nameInputRef$current2 === void 0 ? void 0 : _nameInputRef$current2.value) && {
                name: nameInputRef === null || nameInputRef === void 0 ? void 0 : (_nameInputRef$current3 = nameInputRef.current) === null || _nameInputRef$current3 === void 0 ? void 0 : _nameInputRef$current3.value
              }), {}, {
                email: emailInputRef === null || emailInputRef === void 0 ? void 0 : (_emailInputRef$curren3 = emailInputRef.current) === null || _emailInputRef$curren3 === void 0 ? void 0 : _emailInputRef$curren3.value
              }, (phoneInputRef === null || phoneInputRef === void 0 ? void 0 : (_phoneInputRef$curren = phoneInputRef.current) === null || _phoneInputRef$curren === void 0 ? void 0 : _phoneInputRef$curren.value) && {
                phone: phoneInputRef === null || phoneInputRef === void 0 ? void 0 : (_phoneInputRef$curren2 = phoneInputRef.current) === null || _phoneInputRef$curren2 === void 0 ? void 0 : _phoneInputRef$curren2.value
              }), {}, {
                message: messageInputRef === null || messageInputRef === void 0 ? void 0 : (_messageInputRef$curr2 = messageInputRef.current) === null || _messageInputRef$curr2 === void 0 ? void 0 : _messageInputRef$curr2.value,
                token: token
              });
              (_window = window) === null || _window === void 0 ? void 0 : (_window$fbq = _window.fbq) === null || _window$fbq === void 0 ? void 0 : _window$fbq.call(_window, 'track', router.pathname.includes(constants/* ROUTES.CLASSROOM_RENT */.Z6.CLASSROOM_RENT) ? constants/* FBQ_EVENTS.LEAD */.PT.LEAD : constants/* FBQ_EVENTS.CONTACT */.PT.CONTACT);

              if (!router.pathname.includes(constants/* ROUTES.CLASSROOM_RENT */.Z6.CLASSROOM_RENT)) {
                _context.next = 26;
                break;
              }

              _context.next = 24;
              return contact_service/* contactApi.contactLease */.e.contactLease(data);

            case 24:
              _context.next = 28;
              break;

            case 26:
              _context.next = 28;
              return contact_service/* contactApi.contact */.e.contact(data);

            case 28:
              setIsSent(true);
              setIsLoading(false);
              emailInputRef.current.value = '';
              nameInputRef.current.value = '';
              phoneInputRef.current.value = '';
              messageInputRef.current.value = '';
              _context.next = 39;
              break;

            case 36:
              _context.prev = 36;
              _context.t0 = _context["catch"](17);
              setHasSentError(true);

            case 39:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[17, 36]]);
    }));

    return function handleClick() {
      return _ref2.apply(this, arguments);
    };
  }();

  var verifyRecaptchaCallback = (0,react.useCallback)(function (token) {
    setToken(token);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Background, {
    withoutBackground: withoutBackground,
    children: [hasSentError && /*#__PURE__*/(0,jsx_runtime.jsx)(Alert/* default */.Z, {
      type: Alert/* AlertTypes.error */.d.error,
      message: t('contact.error')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
      withPadding: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Form, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
            tagType: Title/* TitleTagTypes.H3 */.Z.H3,
            alignLeft: true,
            isBlack: true,
            children: t('contact.contact.title')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
            ref: nameInputRef,
            placeholder: t('contact.form.name.placeholder'),
            className: "".concat(hasNameError ? 'error' : '')
          }), hasNameError && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorMessage, {
            children: t('contact.form.name.error')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
            ref: emailInputRef,
            placeholder: t('contact.form.email.placeholder'),
            className: "".concat(hasEmailError ? 'error' : '')
          }), hasEmailError && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorMessage, {
            children: t('contact.form.email.error')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
            ref: phoneInputRef,
            placeholder: t('contact.form.phone.placeholder')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextArea, {
            ref: messageInputRef,
            placeholder: t('contact.form.message.placeholder'),
            className: "".concat(hasMessageError ? 'error' : '')
          }), hasMessageError && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorMessage, {
            children: t('contact.form.message.error')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_google_recaptcha_v3_esm/* GoogleReCaptcha */.mP, {
            onVerify: verifyRecaptchaCallback
          }), (hasNameError || hasEmailError || hasMessageError) && /*#__PURE__*/(0,jsx_runtime.jsx)(GlobalErrorMessage, {
            children: t('contact.form.error')
          }), !isSent && /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            isLoading: isLoading,
            marginTop: 30,
            onClick: handleClick,
            text: "Odeslat"
          }), isSent && /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessMessage, {
            children: t('contact.form.sent')
          })]
        })
      })
    })]
  });
};

/* harmony default export */ var ContactForm = (ContactFormTemplate);

/***/ }),

/***/ 3220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pronajem_uceben; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/components/Footer/Footer.tsx + 1 modules
var Footer = __webpack_require__(90359);
// EXTERNAL MODULE: ./src/components/Header/Header.tsx + 2 modules
var Header = __webpack_require__(50866);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./src/components/Icon/IconTemplate.tsx + 1 modules
var IconTemplate = __webpack_require__(67139);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/RentAdvantages/RentAdvantages.elements.tsx




var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RentAdvantageselements__Wrapper",
  componentId: "sc-1tk1sv7-0"
})(["display:flex;gap:", ";flex-wrap:wrap;margin:", " 0 ", " 0;@media (min-width:", "px){flex-direction:row;justify-content:space-between;}"], (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(35), theme/* breakpoints.sm */.A.sm);
var Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RentAdvantageselements__Section",
  componentId: "sc-1tk1sv7-1"
})(["display:flex;flex-direction:column;align-items:center;width:45%;margin-bottom:", ";@media (min-width:", "px){width:unset;}"], (0,polished_esm/* rem */.hO)(45), theme/* breakpoints.sm */.A.sm);
var SectionIcon = (0,styled_components_browser_esm/* default */.ZP)(IconTemplate/* IconTemplate */._).withConfig({
  displayName: "RentAdvantageselements__SectionIcon",
  componentId: "sc-1tk1sv7-2"
})(["display:block;svg{width:", ";height:", ";}&.coffee,&.wifi{svg{width:", ";height:", ";margin-top:", ";}}"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(60), (0,polished_esm/* rem */.hO)(60), (0,polished_esm/* rem */.hO)(-20));
var SectionLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "RentAdvantageselements__SectionLabel",
  componentId: "sc-1tk1sv7-3"
})(["text-align:center;font-size:", ";font-weight:", ";margin-top:", ";line-height:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.textBase;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(18));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/RentAdvantages/RentAdvantages.tsx









var RentAdvantagesTemplate = function RentAdvantagesTemplate() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
      tagType: Title/* TitleTagTypes.H2 */.Z.H2,
      isBlack: true,
      children: t('classroomRent.advantages.title')
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionIcon, {
          name: Icon/* Icons.Aids */.PJ.Aids
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          dangerouslySetInnerHTML: {
            __html: t('classroomRent.advantages.section1.label')
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionIcon, {
          name: Icon/* Icons.Approve */.PJ.Approve
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          dangerouslySetInnerHTML: {
            __html: t('classroomRent.advantages.section2.label')
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionIcon, {
          className: "coffee",
          name: Icon/* Icons.Coffee */.PJ.Coffee,
          width: 80,
          height: 80
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          dangerouslySetInnerHTML: {
            __html: t('classroomRent.advantages.section3.label')
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionIcon, {
          className: "wifi",
          name: Icon/* Icons.Wifi */.PJ.Wifi
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          dangerouslySetInnerHTML: {
            __html: t('classroomRent.advantages.section4.label')
          }
        })]
      })]
    })]
  });
};

/* harmony default export */ var RentAdvantages = (RentAdvantagesTemplate);
;// CONCATENATED MODULE: ./src/components/RentParameters/RentParameters.elements.tsx



var Background = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RentParameterselements__Background",
  componentId: "sc-68nt0-0"
})(["background:rgba(116,120,129,0.08);padding:", " 0;"], (0,polished_esm/* rem */.hO)(45));
var Note = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "RentParameterselements__Note",
  componentId: "sc-68nt0-1"
})(["width:", ";margin:", " auto ", " auto;padding-left:", ";font-size:", ";@media (min-width:", "px){width:", ";}"], (0,polished_esm/* rem */.hO)(650), (0,polished_esm/* rem */.hO)(-30), (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(25), function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.textBase;
}, theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(800));
var TableWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RentParameterselements__TableWrapper",
  componentId: "sc-68nt0-2"
})(["overflow-x:scroll;margin-top:", ";&::-webkit-scrollbar{display:none;}"], (0,polished_esm/* rem */.hO)(15));
var Table = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
  displayName: "RentParameterselements__Table",
  componentId: "sc-68nt0-3"
})(["border-collapse:separate;border-spacing:", " 0;width:", ";margin:0 auto ", " auto;@media (min-width:", "px){width:", ";}tr,td{height:", ";margin:0 ", ";text-align:center;}th:nth-child(1),td:nth-child(1){text-align:left;padding:0 ", ";}th:nth-child(1){font-weight:bold;}th{font-size:", ";font-weight:", ";span{padding:30px 0;display:inline-block;width:80%;border-bottom:1px solid rgba(116,120,129,0.2);&.withoutBorder{border-bottom:unset;}}.icon{padding:0;border:0;margin-top:", ";svg{width:", ";height:", ";}}}td{font-size:", ";color:", ";line-height:", ";:nth-child(1){color:", ";}}th:nth-child(2),th:nth-child(3),th:nth-child(4),th:nth-child(5){background:white;border-top-left-radius:", ";border-top-right-radius:", ";}td:nth-child(2),td:nth-child(3),td:nth-child(4),td:nth-child(5){background:white;}tr:last-child td:nth-child(2),tr:last-child td:nth-child(3),tr:last-child td:nth-child(4),tr:last-child td:nth-child(5){background-color:rgba(116,120,129,0.04);border-bottom-left-radius:", ";border-bottom-right-radius:", ";}tr:nth-child(3) td:nth-child(2),tr:nth-child(5) td:nth-child(2){background:rgba(116,120,129,0.05);}tr:nth-child(3),tr:nth-child(5),tr:nth-child(7){background-color:rgba(116,120,129,0.04);}"], (0,polished_esm/* rem */.hO)(10), function (props) {
  return props.mobileWidth ? (0,polished_esm/* rem */.hO)(props.mobileWidth) : (0,polished_esm/* rem */.hO)(1000);
}, (0,polished_esm/* rem */.hO)(45), theme/* breakpoints.sm */.A.sm, function (props) {
  return props.desktopWidth ? (0,polished_esm/* rem */.hO)(props.desktopWidth) : (0,polished_esm/* rem */.hO)(1000);
}, (0,polished_esm/* rem */.hO)(60), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(15), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h6;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontWeights.textRegular;
}, (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(50), (0,polished_esm/* rem */.hO)(50), function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.h6;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.grey;
}, (0,polished_esm/* rem */.hO)(26), function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.black;
}, (0,polished_esm/* rem */.hO)(16), (0,polished_esm/* rem */.hO)(16), (0,polished_esm/* rem */.hO)(16), (0,polished_esm/* rem */.hO)(16));
;// CONCATENATED MODULE: ./src/components/RentParameters/RentParameters.tsx










var RentParametersTemplate = function RentParametersTemplate() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Background, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
        tagType: Title/* TitleTagTypes.H3 */.Z.H3,
        isBlack: true,
        children: t('classroomRent.parameters.title')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TableWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Table, {
          desktopWidth: 1000,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("tbody", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("th", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                style: {
                  width: '175px',
                  paddingTop: '80px'
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: t('classroomRent.table.column1.label')
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("th", {
                style: {
                  width: '175px'
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                  name: Icon/* Icons.Capacity2 */.PJ.Capacity2,
                  className: "icon"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: t('classroomRent.table.column2.label')
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("th", {
                style: {
                  width: '175px'
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                  name: Icon/* Icons.Capacity3 */.PJ.Capacity3,
                  className: "icon"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: t('classroomRent.table.column3.label')
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("th", {
                style: {
                  width: '175px'
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
                  name: Icon/* Icons.Capacity1 */.PJ.Capacity1,
                  className: "icon"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: t('classroomRent.table.column4.label')
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                children: t('classroomRent.table.row1.label')
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                children: "5,7 m x 7,6 m"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                children: "a\u017E 24"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                children: "a\u017E 12"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                children: "a\u017E 28"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                children: t('classroomRent.table.row2.label')
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                children: "7,5 m x 9,8 m"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                children: "a\u017E 48"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                children: "a\u017E 16"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                children: "a\u017E 56"
              })]
            })]
          })
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
      withPadding: true,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
        tagType: Title/* TitleTagTypes.H3 */.Z.H3,
        isBlack: true,
        children: t('classroomRent.prices.title')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TableWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Table, {
          desktopWidth: 800,
          mobileWidth: 650,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("tbody", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: t('classroomRent.prices.table1.row1.label')
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                style: {
                  width: '200px'
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: "Cena (bez DPH)"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                style: {
                  width: '200px'
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: "Cena (bez DPH)"
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                children: t('classroomRent.prices.table1.row2.label')
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                style: {
                  width: '200px'
                },
                children: "2 000 K\u010D/hod"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                style: {
                  width: '200px'
                },
                children: "14 000 K\u010D/den*"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                children: t('classroomRent.prices.table1.row3.label')
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                style: {
                  width: '200px'
                },
                children: "3 000 K\u010D/hod"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                style: {
                  width: '200px'
                },
                children: "20 000 K\u010D/den*"
              })]
            })]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Note, {
        children: ["*", t('classroomRent.prices.table1.row2.note')]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TableWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Table, {
          desktopWidth: 800,
          mobileWidth: 500,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("tbody", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: t('classroomRent.prices.table2.row1.label')
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                style: {
                  width: '200px'
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: "Cena (bez DPH)"
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                children: t('classroomRent.prices.table2.row2.label')
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                style: {
                  width: '200px'
                },
                children: "V cen\u011B"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                children: t('classroomRent.prices.table2.row3.label')
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                style: {
                  width: '200px'
                },
                children: "V cen\u011B"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                children: t('classroomRent.prices.table2.row4.label')
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                style: {
                  width: '200px'
                },
                children: "V cen\u011B"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                children: t('classroomRent.prices.table2.row5.label')
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                style: {
                  width: '200px'
                },
                children: "590 K\u010D/den"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                children: t('classroomRent.prices.table2.row6.label')
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                style: {
                  width: '200px'
                },
                children: "1 000 K\u010D/den"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                children: t('classroomRent.prices.table2.row7.label')
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                style: {
                  width: '200px'
                },
                children: "200 K\u010D"
              })]
            })]
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TableWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Table, {
          desktopWidth: 800,
          mobileWidth: 500,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("tbody", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("tr", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "withoutBorder",
                  children: t('classroomRent.prices.table3.row1.label')
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("tr", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                children: t('classroomRent.prices.table3.row1.description')
              })
            })]
          })
        })
      })]
    })]
  });
};

/* harmony default export */ var RentParameters = (RentParametersTemplate);
// EXTERNAL MODULE: ./src/components/ContactForm/ContactForm.tsx + 1 modules
var ContactForm = __webpack_require__(26308);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
;// CONCATENATED MODULE: ./src/components/RentSupport/RentSuport.elements.tsx



var RentSuport_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RentSuportelements__Wrapper",
  componentId: "sc-1itsy8t-0"
})(["display:flex;flex-direction:column;align-items:center;@media (min-width:", "px){flex-direction:row;gap:", ";align-items:unset;}"], theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(40));
var ContactPerson = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "RentSuportelements__ContactPerson",
  componentId: "sc-1itsy8t-1"
})(["width:", ";box-shadow:0 5px 10px 0 rgba(0,0,0,0.15);border-radius:", ";padding:", ";margin:0 0 ", " 0;@media (min-width:", "px){margin:", " 0;}"], (0,polished_esm/* rem */.hO)(310), (0,polished_esm/* rem */.hO)(16), (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(80), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(100));
var ContactPersonLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "RentSuportelements__ContactPersonLabel",
  componentId: "sc-1itsy8t-2"
})(["font-weight:", ";font-size:", ";font-family:", ";display:block;padding-bottom:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h4;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontSecondary;
}, (0,polished_esm/* rem */.hO)(30));
var ContactPersonImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "RentSuportelements__ContactPersonImage",
  componentId: "sc-1itsy8t-3"
})(["width:", ";border-radius:", ";margin-bottom:", ";"], (0,polished_esm/* rem */.hO)(260), (0,polished_esm/* rem */.hO)(16), (0,polished_esm/* rem */.hO)(20));
var ContactPersonName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "RentSuportelements__ContactPersonName",
  componentId: "sc-1itsy8t-4"
})(["font-weight:", ";font-size:", ";display:block;font-family:", ";padding-bottom:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontWeights.textBold;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSizes.h6;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fonts.fontSecondary;
}, (0,polished_esm/* rem */.hO)(15));
var ContactPersonDescription = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "RentSuportelements__ContactPersonDescription",
  componentId: "sc-1itsy8t-5"
})(["color:", ";display:block;padding-bottom:", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.grey;
}, (0,polished_esm/* rem */.hO)(10));
var ContactPersonPhone = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "RentSuportelements__ContactPersonPhone",
  componentId: "sc-1itsy8t-6"
})(["color:", ";"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.grey;
});
;// CONCATENATED MODULE: ./src/components/RentSupport/RentSupport.tsx









var RentSupportTemplate = function RentSupportTemplate() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Content/* default */.Z, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(RentSuport_elements_Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ContactForm/* default */.Z, {
        withoutBackground: true
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ContactPerson, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ContactPersonLabel, {
          children: t('classroomRent.support.person.label')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactPersonImage, {
          src: (0,url_utils/* publicAssets */.VK)('/team_person9.webp')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactPersonName, {
          children: "Vanesa Rajchartov\xE1"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactPersonDescription, {
          dangerouslySetInnerHTML: {
            __html: t('classroomRent.support.person.description')
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContactPersonPhone, {
          children: "+420 734 156 851"
        })]
      })]
    })
  });
};

/* harmony default export */ var RentSupport = (RentSupportTemplate);
// EXTERNAL MODULE: ./src/ui/Hero/Hero.tsx + 1 modules
var Hero = __webpack_require__(29135);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
;// CONCATENATED MODULE: ./src/pages/pronajem-uceben.tsx














var ClassroomRent = function ClassroomRent() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: t('seo.classroomRent.title'),
      description: "",
      noindex: !constants/* IS_PROD */.XK,
      nofollow: !constants/* IS_PROD */.XK
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Hero/* default */.Z, {
      titleKey: "classroomRent.hero.title",
      imageKey: "classroom_rent_hero.png",
      descriptionKey: "classroomRent.hero.paragraph"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(RentAdvantages, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(RentParameters, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(RentSupport, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
};

/* harmony default export */ var pronajem_uceben = (ClassroomRent);

/***/ }),

/***/ 20644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ contactApi; }
/* harmony export */ });
/* harmony import */ var _core_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84107);

var CONTACT = 'pv/contact';
var LEASE = 'pv/contact/lease-form';
var COMPANY_COURSES_ORDER = 'pv/contact/company-course-form';
var contactApi = {
  contact: function contact(data) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(CONTACT, data);
  },
  contactLease: function contactLease(data) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(LEASE, data);
  },
  companyCoursesOrder: function companyCoursesOrder(data) {
    return _core_service__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(COMPANY_COURSES_ORDER, data);
  }
};

/***/ }),

/***/ 29135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Hero; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/components/Icon/IconTemplate.tsx + 1 modules
var IconTemplate = __webpack_require__(67139);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/ui/Hero/Hero.elements.tsx




var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__Wrapper",
  componentId: "sc-1nsgps3-0"
})(["display:flex;padding:", " ", ";max-width:", ";margin:", " auto ", " auto;min-height:", ";flex-direction:column-reverse;@media (min-width:", "px){margin:", " auto ", " auto;}@media (min-width:", "px){flex-direction:row;align-items:center;padding:0;}"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(1180), (0,polished_esm/* rem */.hO)(constants/* MOBILE_HEADER_HEIGHT */.ZQ), (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(500), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(constants/* DESKTOP_HEADER_HEIGHT */.cf), (0,polished_esm/* rem */.hO)(40), theme/* breakpoints.md */.A.md);
var Label = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Heroelements__Label",
  componentId: "sc-1nsgps3-1"
})(["font-size:", ";line-height:", ";display:flex;margin-bottom:", ";svg{width:", ";height:", ";margin-right:", ";margin-top:", ";polyline{stroke:black;}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(26), (0,polished_esm/* rem */.hO)(14), (0,polished_esm/* rem */.hO)(22), (0,polished_esm/* rem */.hO)(22), (0,polished_esm/* rem */.hO)(8), (0,polished_esm/* rem */.hO)(2));
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Heroelements__Image",
  componentId: "sc-1nsgps3-2"
})(["width:100%;border-radius:", ";height:auto;margin-top:", ";@media (min-width:", "px){display:block;margin-top:", ";width:", ";}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(0), (0,polished_esm/* rem */.hO)(600));
var About = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__About",
  componentId: "sc-1nsgps3-3"
})(["@media (min-width:", "px){padding-left:", ";}"], theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(65));
var Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "Heroelements__Title",
  componentId: "sc-1nsgps3-4"
})(["font-weight:", ";font-size:", ";font-family:", ";padding-bottom:", ";@media (min-width:", "px){font-size:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.h3;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fonts.fontSecondary;
}, (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.md */.A.md, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSizes.h2;
});
var Description = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "Heroelements__Description",
  componentId: "sc-1nsgps3-5"
})(["font-size:", ";font-weight:", ";padding:", " 0 ", " 0;line-height:", ";color:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontSizes.h6;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontWeights.textRegular;
}, (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(30), function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.grey;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/Hero/Hero.tsx









var HeroTemplate = function HeroTemplate(_ref) {
  var titleKey = _ref.titleKey,
      imageKey = _ref.imageKey,
      descriptionKey = _ref.descriptionKey,
      listKeys = _ref.listKeys;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
      src: (0,url_utils/* publicAssets */.VK)("/".concat(imageKey))
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(About, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
        dangerouslySetInnerHTML: {
          __html: t(titleKey)
        }
      }), descriptionKey && /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
        dangerouslySetInnerHTML: {
          __html: t(descriptionKey)
        }
      }), (listKeys === null || listKeys === void 0 ? void 0 : listKeys.length) > 0 && (listKeys === null || listKeys === void 0 ? void 0 : listKeys.map(function (listKey, key) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(Label, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
            name: Icon/* Icons.CheckThin */.PJ.CheckThin
          }), ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            dangerouslySetInnerHTML: {
              __html: t(listKey)
            }
          })]
        }, key);
      }))]
    })]
  });
};

/* harmony default export */ var Hero = (HeroTemplate);

/***/ }),

/***/ 83297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TitleTagTypes; },
  "C": function() { return /* binding */ Title; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/ui/SectionTitle/Title.element.tsx



var TitleStyles = (0,styled_components_browser_esm/* css */.iv)(["font-size:", ";line-height:", ";font-weight:", ";font-family:", ";padding:", ";", ";@media (min-width:", "px){", ";padding:", ";font-size:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h4;
}, (0,polished_esm/* rem */.hO)(40), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontSecondary;
}, function (prop) {
  return prop.withoutPadding ? 0 : "".concat((0,polished_esm/* rem */.hO)(20), " 0");
}, function (prop) {
  return prop.isBlack ? "color: ".concat(prop.theme.colors.black) : "color: ".concat(prop.theme.colors.primary);
}, theme/* breakpoints.sm */.A.sm, function (prop) {
  return prop.alignLeft ? 'text-align: left' : 'text-align: center';
}, function (prop) {
  return prop.withoutPadding ? 0 : "".concat((0,polished_esm/* rem */.hO)(20), " 0 ").concat((0,polished_esm/* rem */.hO)(45), " 0");
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.h3;
});
var WrapperDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Titleelement__WrapperDiv",
  componentId: "sc-s8z71i-0"
})(["", ""], TitleStyles);
var WrapperH1 = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "Titleelement__WrapperH1",
  componentId: "sc-s8z71i-1"
})(["", ""], TitleStyles);
var WrapperH2 = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "Titleelement__WrapperH2",
  componentId: "sc-s8z71i-2"
})(["", ""], TitleStyles);
var WrapperH3 = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "Titleelement__WrapperH3",
  componentId: "sc-s8z71i-3"
})(["", ""], TitleStyles);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/SectionTitle/Title.tsx



var TitleTagTypes;

(function (TitleTagTypes) {
  TitleTagTypes["H1"] = "h1";
  TitleTagTypes["H2"] = "h2";
  TitleTagTypes["H3"] = "h3";
})(TitleTagTypes || (TitleTagTypes = {}));

var TitleTemplate = function TitleTemplate(_ref) {
  var children = _ref.children,
      alignLeft = _ref.alignLeft,
      withoutPadding = _ref.withoutPadding,
      isBlack = _ref.isBlack,
      tagType = _ref.tagType;

  if (tagType === TitleTagTypes.H1) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH1, {
      withoutPadding: withoutPadding,
      alignLeft: alignLeft,
      isBlack: isBlack,
      children: children
    });
  }

  if (tagType === TitleTagTypes.H3) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH3, {
      withoutPadding: withoutPadding,
      alignLeft: alignLeft,
      isBlack: isBlack,
      children: children
    });
  }

  if (tagType === TitleTagTypes.H2) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH2, {
      withoutPadding: withoutPadding,
      alignLeft: alignLeft,
      isBlack: isBlack,
      children: children
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperDiv, {
    withoutPadding: withoutPadding,
    alignLeft: alignLeft,
    isBlack: isBlack,
    children: children
  });
};

/* harmony default export */ var Title = (TitleTemplate);

/***/ }),

/***/ 37397:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pronajem-uceben",
      function () {
        return __webpack_require__(3220);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4913,5897,9774,2888,179], function() { return __webpack_exec__(37397); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);